module.exports = __webpack_public_path__ + "img/emoji_90.5b99d4be.png";